import { bookingStatus } from "components/Common/constants"
import TableShimmer from "components/Shared/TableShimmer"
import formatDateTime from "components/Shared/formatDateTime"
import LtrText from "components/Shared/LtrText"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import { getDashboardKpiBookings } from "store/actions/dashboardAction"
import Select from "components/Shared/TranslatedSelect"
import { Pie } from "react-chartjs-2"

const Bookings = ({
  mapSeriesData,
  bookingModal,
  setBookingModal,
  formatDate,
  bookingType,
  setBookingType,
  setBookingDateRange,
  functionRef,
  commonDateRange,
  t,
  language,
  hasBookingsPermission,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { loading, dashboardBookingsData } = useSelector(
    state => state.Dashboard
  )

  const [bookingsTypeData, setBookingsTypeData] = useState([])
  const [totalBookingsType, setTotalBookingsType] = useState(null)
  const [totalBookingsStatus, setTotalBookingsStatus] = useState(null)
  const [bookingsStatusData, setBookingsStatusData] = useState([])
  const [isLoading, setIsLoading] = useState(null)

  const [options, setOptions] = useState({
    chart: {
      id: "line-chart",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 2,
      curve: "smooth",
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      tickAmount: 3,
      min: 0,
      // max: 3,
      labels: {
        formatter: function (val) {
          return Math.round(val)
        },
      },
    },
  })

  // PIE CHART
  const [pieBookingTypeData, setPieBookingTypeData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderColor: [],
      },
    ],
  })
  const [peiBookingStatusData, setPeiBookingStatusData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderColor: [],
      },
    ],
  })

  useEffect(() => {
    getDashboardBookings()
  }, [commonDateRange])

  useEffect(() => {
    if (
      dashboardBookingsData &&
      dashboardBookingsData.graphData &&
      dashboardBookingsData.graphData.allReservations
    ) {
      const allReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.allReservations?.series
      )
      const truckReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.truckReservations?.series
      )
      const premiumReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.premiumReservations?.series
      )

      const updatedReservationSeries = [
        ...allReservationsSeries,
        ...truckReservationsSeries,
        ...premiumReservationsSeries,
      ]

      const categories = dashboardBookingsData?.graphData?.categories
      const localizedCategories = categories

      const totalBookingsTypeCount = allReservationsSeries.reduce(
        (sum, series) => {
          return (
            sum + series.data.reduce((seriesSum, value) => seriesSum + value, 0)
          )
        },
        0
      )
      setTotalBookingsType(totalBookingsTypeCount)

      setBookingsTypeData(updatedReservationSeries)
      setOptions(prevOptions => ({
        ...prevOptions,
        xaxis: {
          ...prevOptions.xaxis,
          categories: localizedCategories,
        },
      }))

      //

      const pendingReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.pendingReservations?.series
      )

      const openReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.openReservations?.series
      )
      const confirmedReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.confirmedReservations?.series
      )
      const completedReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.completedReservations?.series
      )
      const cancelledReservationsSeries = mapSeriesData(
        dashboardBookingsData?.graphData?.cancelledReservations?.series
      )

      const updatedBookingsStatusData = [
        ...pendingReservationsSeries,
        ...openReservationsSeries,
        ...confirmedReservationsSeries,
        ...completedReservationsSeries,
        ...cancelledReservationsSeries,
      ]

      const totalBookingsStatusCount = updatedBookingsStatusData.reduce(
        (sum, series) => {
          return (
            sum + series.data.reduce((seriesSum, value) => seriesSum + value, 0)
          )
        },
        0
      )

      setTotalBookingsStatus(totalBookingsStatusCount)

      setBookingsStatusData(updatedBookingsStatusData)

      // CONVERT DATA FORMAT TO PIE CHART
      const pieChartData1 = convertToPieChartData(
        dashboardBookingsData.graphData,
        ["truck", "premium"]
      )
      const pieChartData2 = convertToPieChartData(
        dashboardBookingsData.graphData,
        ["pending", "open", "confirmed", "completed", "cancelled"]
      )
      setPieBookingTypeData(pieChartData1)
      setPeiBookingStatusData(pieChartData2)

      setTimeout(() => {
        setIsLoading(false)
      }, 1000)
    }
  }, [dashboardBookingsData, language])

  const getDashboardBookings = () => {
    // Only fetch if user has Bookings permission
    if (!hasBookingsPermission) return
    
    const updatedBookingType = bookingType?.map(item => item.value) || []
    setIsLoading(true)
    const payload = {
      bookingType: updatedBookingType,
      dateRange: commonDateRange,
    }
    dispatch(getDashboardKpiBookings(payload))
  }

  const renderTicketStatus = actionType => {
    return bookingStatus[actionType] || ""
  }

  // const handleCustomDateRangeChange = value => {
  //   if (
  //     Array.isArray(value) &&
  //     value.length === 2 &&
  //     value[0] instanceof Date &&
  //     !isNaN(value[0]) &&
  //     value[1] instanceof Date &&
  //     !isNaN(value[1])
  //   ) {
  //     setBookingDateRange({
  //       start: formatDate(value[0]),
  //       end: formatDate(value[1]),
  //     })
  //   } else {
  //     // Optionally, reset to default or previous valid state
  //     setBookingDateRange({})
  //   }
  // }

  const handleBookingFilter = () => {
    const updatedBookingType = bookingType?.map(item => item.value) || []
    setIsLoading(true)
    const payload = {
      bookingType: updatedBookingType,
      dateRange: commonDateRange,
    }
    dispatch(getDashboardKpiBookings(payload))
    setBookingModal(false)
  }

  useEffect(() => {
    if (functionRef) {
      functionRef.current = getDashboardBookings
    }
  }, [functionRef])

  const convertToPieChartData = (graphData, reservationTypes) => {
    if (!graphData) {
      console.error("GraphData is undefined or null")
      return { labels: [], datasets: [{ data: [] }] }
    }

    const labels = []
    const dataValues = []
    const backgroundColors = []
    const borderColors = []

    const colorPalette = [
      ["rgba(255, 99, 132, 0.8)", "rgba(255, 99, 132, 1)"],
      ["rgba(54, 162, 235, 0.8)", "rgba(54, 162, 235, 1)"],
      ["rgba(255, 206, 86, 0.8)", "rgba(255, 206, 86, 1)"],
      ["rgba(75, 192, 192, 0.8)", "rgba(75, 192, 192, 1)"],
      ["rgba(153, 102, 255, 0.8)", "rgba(153, 102, 255, 1)"],
      ["rgba(255, 159, 64, 0.8)", "rgba(255, 159, 64, 1)"],
      ["rgba(199, 199, 199, 0.8)", "rgba(199, 199, 199, 1)"],
      ["rgba(83, 102, 255, 0.8)", "rgba(83, 102, 255, 1)"],
    ]

    reservationTypes.forEach((type, index) => {
      const key = `${type}Reservations`
      if (graphData[key] && graphData[key].series && graphData[key].series[0]) {
        labels.push(graphData[key].series[0].name)
        dataValues.push(
          graphData[key].series[0].data.reduce((a, b) => a + b, 0)
        )
        backgroundColors.push(colorPalette[index % colorPalette.length][0])
        borderColors.push(colorPalette[index % colorPalette.length][1])
      }
    })

    const datasets = [
      {
        label: "",
        data: dataValues,
        backgroundColor: backgroundColors,
        borderColor: borderColors,
        // borderWidth: 1,
      },
    ]
    const localizedLabels = labels.map(item => t(item))
    return { labels: localizedLabels, datasets }
  }

  return (
    <div>
      <Row>
        {/* <Col lg={6}>
          <Card>
            <CardBody>
              <CardTitle className="d-flex justify-content-between">
                <span>{t("Bookings (Types)")} </span>
                <span>{totalBookingsType}</span>
              </CardTitle>
              {isLoading ? (
                <ShimmerThumbnail height={300} rounded />
              ) : (
                <>
                  <ReactApexChart
                    series={bookingsTypeData}
                    options={options}
                    type="line"
                    height={320}
                    className="apex-charts"
                  />
                </>
              )}
            </CardBody>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            <CardBody>
              <CardTitle className="d-flex justify-content-between">
                <span>{t("Bookings (Status)")}</span>
                <span>{totalBookingsStatus}</span>
              </CardTitle>
              {isLoading ? (
                <ShimmerThumbnail height={300} rounded />
              ) : (
                <>
                  <ReactApexChart
                    series={bookingsStatusData}
                    options={options}
                    type="line"
                    height={320}
                    className="apex-charts"
                  />
                </>
              )}
            </CardBody>
          </Card>
        </Col> */}

        <Col lg={6}>
          <Card className="booking_pie_chart full_height_card">
            <CardBody style={{ maxHeight: 430 }}>
              <CardTitle className="">
                <span>{t("Bookings (Types)")}</span>
              </CardTitle>
              {isLoading ? (
                <ShimmerThumbnail height={320} rounded />
              ) : (
                <div style={{ maxHeight: 230 }}>
                  <Pie
                    height={240}
                    data={pieBookingTypeData}
                    options={{
                      plugins: {
                        legend: {
                          display: true,
                          position: "bottom",
                        },
                      },
                    }}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="booking_pie_chart">
            <CardBody style={{ maxHeight: 430 }}>
              <CardTitle className="">
                <span>{t("Bookings (Status)")}</span>
              </CardTitle>
              {isLoading ? (
                <ShimmerThumbnail height={320} rounded />
              ) : (
                <>
                  <Pie
                    height={290}
                    data={peiBookingStatusData}
                    options={{
                      plugins: {
                        legend: {
                          display: true,
                          position: "bottom",
                        },
                      },
                    }}
                  />
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Card>
          <CardBody>
            <CardTitle>{t("Bookings Statistics")}</CardTitle>
            <div className="table-responsive" style={{ maxHeight: 600 }}>
              {loading ? (
                <TableShimmer row={6} col={7} />
              ) : dashboardBookingsData?.tableData?.length === 0 ? (
                <p className="text-center my-2">
                  {t("No bookings data found")}
                </p>
              ) : (
                <>
                  <Table className="table mb-0 " hover>
                    <thead className="table-light fixed_thead">
                      <tr>
                        <th>{t("S. No.")}</th>
                        <th>{t("Booking Id")}</th>
                        <th>{t("Name")}</th>
                        <th>{t("Phone Number")}</th>
                        <th>{t("Date & Time Of Event")}</th>
                        <th>{t("Venue")}</th>
                        <th>{t("Status")}</th>
                      </tr>
                    </thead>
                    <tbody style={{ maxHeight: 300 }}>
                      {dashboardBookingsData?.tableData?.map((item, index) => (
                        <tr
                          key={item._id}
                          onClick={() => {
                            navigate(`/bookings/booking-details?id=${item._id}`)
                          }}
                          className="cursor-pointer"
                        >
                          <td>{index + 1}</td>
                          <td>{item.bookingId}</td>
                          <td>{item?.userId?.name || "-"}</td>
                          <td>
                            {item?.userId?.phoneNumber ? (
                              <LtrText>{item.userId.phoneNumber}</LtrText>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            {formatDateTime(item?.dateTimeOfEvent) || "-"}
                          </td>
                          <td>{item?.venue || "-"}</td>
                          <td>{t(renderTicketStatus(item?.status)) || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <div className="d-flex justify-content-end mt-3">
                    <Link className="" to={"/bookings"}>
                      {t("View All")}
                    </Link>
                  </div>
                </>
              )}
            </div>
          </CardBody>
        </Card>
      </Row>
      <Modal isOpen={bookingModal} toggle={() => setBookingModal(false)}>
        <ModalHeader toggle={() => setBookingModal(false)}>
          {t("Filter")}
        </ModalHeader>
        <ModalBody>
          <div>
            <Label>{t("Select Bookings Types")}</Label>
            <Select
              value={bookingType}
              isMulti={true}
              onChange={item => setBookingType(item)}
              options={[
                { label: t("Premium"), value: "premium" },
                { label: t("Truck"), value: "truck" },
              ]}
              placeholder={t("Select Bookings Types")}
              closeMenuOnSelect={false}
            />
          </div>
        </ModalBody>
        <ModalFooter className="mb-3 mt-4">
          <Button color="secondary" onClick={() => setBookingModal(false)}>
            {t("Cancel")}
          </Button>
          <Button color="primary" onClick={handleBookingFilter}>
            {t("Save")}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default Bookings
